import { Stack, Typography } from "@mui/material";
import type { DataCollectionRequestTemplateVersion } from "../../../../api/types/dataCollectionTypes";

interface Props {
  template: DataCollectionRequestTemplateVersion;
}

const DataRequestTemplatePageTitle = ({ template }: Props) => {
  return (
    <Stack spacing={0.5} sx={{ py: 1.5 }}>
      <Typography variant="h6" noWrap>
        {template.name}
      </Typography>
      <Typography variant="caption" color="textSecondary">
        Data Request Template
      </Typography>
    </Stack>
  );
};

export default DataRequestTemplatePageTitle;
